<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev"><a routerLink="/create-new-customer">Add new Customer Service User
                Information</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">List of Customer Service User</span>
        <!-- <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Plant Details</span> -->
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">List of Customer Service User</h2>
    </div>

    <div
        class="search_bar border-top border-bottom border-light mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mb-4 mb-md-5">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                <div class="pt-3 pb-3" [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual"
                    #p="ngbPopover" (click)="openPopover(p)" (clickOutside)="onClickedOutside($event)"
                    placement="bottom" popoverClass='search_select_popover' class="border-right border-light py-3 px-0">
                    <span class="_popover_label">Groups</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedGroupName}}</div>
                    <ng-template #popContent>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroup" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let group of mainGroups | filter: searchGroup;let i=index"
                                    [ngClass]="(multiSelectGroup == group?.groupName || (group.groupName == null && multiSelectGroup.length == 0)) && 'active'"
                                    (click)="selectGroupid(group)">
                                    {{group?.groupName}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroup == group?.groupName || (group.groupName == null && multiSelectGroup.length == 0)"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-8 col-xl-9 search_form">
                <div class="search_form h-100">
                    <svg-icon src="../../../assets/images/icons/search.svg"></svg-icon>
                    <input class="search_field h-100" type="text" name="searchText" id="menu-search"
                        [(ngModel)]="searchText" placeholder="Type here to search…" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)">
                </div>
            </div>
        </div>
    </div>

    <div class="mb-4 mb-md-5 d-flex align-items-center justify-content-between">
        <h3 class="h6 font-weight-bold text-dark">{{totalRows}}
            Customer Service User{{totalRows > 1 ? 's' : null}}</h3>
        <div class="d-flex align align-items-center column-gap-2">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="masterSelectedUsers" name="list_name"
                    value="m1" (change)="checkUncheckAll()" id="all_list_name">
                <label class="custom-control-label cursor-pointer" for="all_list_name">Select all</label>
            </div>
            <div ngbDropdown *ngIf="showDropdown">
                <button type="button" class="dropdown_dots px-2 text-primary" id="download_dropdown" ngbDropdownToggle>
                    <svg-icon src="../../../assets/images/icons/more_dots.svg"
                        [svgStyle]="{ 'height.px':20 }"></svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="download_dropdown">
                    <button ngbDropdownItem (click)="openModalMoveGroup(checkedOnlyUsersList)">Move to new
                        group</button>
                </div>
            </div>
        </div>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-4" *ngFor="let serviceuser of newmainServiceUserList | filter:searchText | paginate: { itemsPerPage: 12,
            currentPage: page, totalItems:newmainServiceUserList?.length }; let i=index ">
            <div class="bg-lighter p-3 rounded h-100 d-flex flex-column">
                <div class="d-flex align-items-start column-gap-2 mb-2">
                    <div class="custom-control custom-checkbox flex-shrink-0 pt-2">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="serviceuser.isSelected"
                            name="list_name" [id]="serviceuser.userId + 'list_name'" value="{{serviceuser.userId}}"
                            (change)="isAllSelected()">
                        <label [for]="serviceuser.userId + 'list_name'"
                            class="custom-control-label cursor-pointer"></label>
                    </div>
                    <div class="list_image">
                        <img src="./assets/images/add-admin.png" alt="">
                    </div>
                    <div class="pl-2">
                        <h3 class="font-weight-bold text-primary h5 mb-1 mb-md-2 cursor-pointer"
                            (click)="goToServiceUserDetails(serviceuser.userId)">{{serviceuser.userName}}</h3>
                        <span class="font-weight-normal d-block small mb-1">username:
                            {{serviceuser.userNameInShort}}</span>
                        <span class="font-weight-normal d-block small mb-0">Customer Service Group:
                            <ng-container class="font-weight-normal small mb-0"
                                *ngFor="let userallgroup of serviceuser.groups;let last = last">{{userallgroup}}{{ !last
                                ? ', ' : '' }}</ng-container>
                        </span>
                    </div>
                </div>
                <span
                    (click)="openModal(serviceuser.userName, serviceuser.userNameInShort, serviceuser.userId, groupId, fromDetailsPage)"
                    class="font-weight-bold small mb-0 mt-auto cursor-pointer text-primary">Remove from all
                    group</span>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="mainServiceUserList?.length > 12">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelServiceUserList($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{indexPage}}/{{paginationCount(mainServiceUserList?.length)}}</div>
                <!-- <div class="page_numbers">
                    {{paginationCount(mainServiceUserList?.length)}}/{{indexPage}}</div> -->
            </div>
        </div>
    </div>
</div>